import { useView } from "../../context/ViewContext";

const ContentLayout = ({ children }: { children: React.ReactNode }) => {
  const { view } = useView();

  // Image Studio manages its own full-bleed, full-height layout. The chat keeps
  // the centered, readable max-width column.
  if (view === "studio") {
    return <main className="bg-surface text-primary">{children}</main>;
  }

  return (
    <main className="bg-surface text-primary min-h-screen">
      <div className="max-w-screen-lg mx-4 lg:mx-auto">{children}</div>
    </main>
  );
};

export default ContentLayout;
